import React from 'react';
import RefLink from '../shared/RefLink';
import { engagementLabelsOf } from './CoverageDisplay';
import { STATUS_META, coverageList, coverageListItem } from './constants';

// "Submitted Together With" — the other requests filed on the same page
// (Signed Financial Statements / QC35 Form batch submission). Each is its own
// request; the links open in a new tab like every cross-document link.
// siblings: [{ id, requestNo, status, engagementId, engagementName, serviceDescription, aiApproved? }]
// `current` is this request's engagement: a sibling of the same company then
// also shows its engagementTag (service, number, serviceDescription), so the
// two can be told apart.
const BatchSiblings = ({ siblings, current = null, basePath }) => {
  const labels = engagementLabelsOf([
    ...(current ? [current] : []),
    ...siblings.map((b) => ({ ...b, id: b.engagementId })),
  ]);
  return (
    <ul className={coverageList}>
      {siblings.map((b) => (
        <li key={b.id} className={coverageListItem}>
          <RefLink to={`${basePath}/${b.id}`} className="text-blue-600 hover:underline font-medium">{b.requestNo}</RefLink>
          {' '}<span className="text-slate-600">{(labels[b.engagementId] || {}).text || b.engagementName}</span>
          {' '}<span className="text-xs text-slate-500">· {b.aiApproved ? 'Approved automatically' : (STATUS_META[b.status]?.label || b.status)}</span>
        </li>
      ))}
    </ul>
  );
};

export default BatchSiblings;
